module.exports = __webpack_public_path__ + "static/media/email-dark.43ba16ad.svg";